<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import "./style/page.scss";

  export default {
  name: "app",
};
</script>
